import React, { Fragment } from 'react'
import { tooltips } from '../../constants/tooltipInfo'

const ToolTip = ({ name, tooltipDisabled }) => {
    return (
        <Fragment>
            {!tooltipDisabled ? (
                <span
                    className='tooltip-toggle'
                    aria-label={`${tooltips[name]}`}
                    tabIndex='0'
                >
                    ?
                </span>
            ) : null}
        </Fragment>
    )
}

export default ToolTip
